import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  PositionOption,
  positionsKey,
  positionsRoute,
} from '@features/positions';
import axiosInstance from '@server/axiosInstance';

type UsePositionsProps = {
  setPositions?: Dispatch<SetStateAction<PositionOption[]>>;
  industryId: number;
};

export const useGetPositions = ({
  setPositions = () => {},
  industryId,
}: UsePositionsProps) => {
  const { data: positionsData, isFetching: isLoadingPositions } = useQuery({
    queryKey: [positionsKey, industryId],
    queryFn: ({ queryKey: [, id] }) =>
      axiosInstance
        .get(`${positionsRoute}?industry_id=${id}`)
        .then((res) => res.data),
    onSuccess: (data: { object: PositionOption[] }) => {
      if (data.object) {
        setPositions([
          { name: "I can't find the position I need", id: 0 },
          ...data.object,
        ]);
      }
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(industryId),
  });

  return {
    positionsData,
    isLoadingPositions,
  };
};
